import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message} from 'antd';
import {Route, Switch} from "react-router-dom";
import Create from './create';
import {
  createResource,
  deleteResource,
  fetchResource,
  getAllStatus,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/JobCardStatus";

import {searchManpower} from "../../appRedux/actions/Manpower";
import {fetchFilter, fetchRelationshipSearchData} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import ListCard from "../../components/ListCard";
import * as _ from 'lodash';

export class JobCardStatus extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    // this.fetchList();
    // this.props.fetchFilter(this.props.resourceName);
    this.props.getAllStatus();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({
        visibleColumns: columns
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
    if(nextProps && nextProps.filters && nextProps.filters['changeStatus'] && JSON.stringify(nextProps.filters['changeStatus']) !== JSON.stringify(this.props.filters['changeStatus'])) {
      this.props.getAllStatus();
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  jobCardSearchChange = (e) => {
    this.props.fetchRelationshipSearchData(e, 'JobCard', 'jobCardNo');
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    Object.keys(filters).forEach((item) => {

      if(item === '_id') {
        return;
      }

      if(selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Update Status</Button>
          }}/>

          {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'d'}*/}
          {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
          {/*  return <Popconfirm*/}
          {/*    title="Are you sure you want to delete this record?"*/}
          {/*    onConfirm={() => {*/}
          {/*      this.deleteResource(record._id)*/}
          {/*    }}*/}
          {/*    onCancel={this.cancelDelete}*/}
          {/*    okText="Yes"*/}
          {/*    cancelText="No"*/}
          {/*  >*/}
          {/*    <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>*/}
          {/*  </Popconfirm>*/}
          {/*}}/>*/}

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id, urlBackToJobCard) => {
    this.props.updateResource(values, id, urlBackToJobCard);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, this.state.columns, "JobCardStatus");
  }

  searchManpower = (id) => {
    this.props.searchManpower(id);
  };

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, manpower, status, searchedJobCard} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);

    return (<div>
      <h2>{'Job Card Status'}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <ListCard columns={columns}
                                       visibleColumn={visibleColumns}
                                       data={data}
                                       searchedJobCard={searchedJobCard}
                                       clearFilter={this.clearAll}
                                       filters={filters}
                                       handleChange={this.handleChange}
                                       columnChange={this.handleColumnChange}
                                       downloadToCSV={this.downloadToCSV}
                                       title={resourceName}
                                       size={'middle'}
                                       create={this.create}
                                       pagination={this.props.query.pagination}
                                       loading={loading}
                                       authUser={authUser}
                                       selectJobCard={this.edit}
                                       jobCardSearchChange={this.jobCardSearchChange}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          status={status}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          loading={loading}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          status={status}
                                          resource={resourceName}
                                          searchManpower={this.searchManpower}
                                          fetch={fetchResource}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.updateResource}
                                          loading={loading}
                                          manpower={manpower}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, jobCardStatus, manpower, commonData}) => {
  return {
    authUser: auth.authUser,
    total: jobCardStatus.total,
    data: jobCardStatus.resources,
    resource: jobCardStatus.resource,
    edit: jobCardStatus.edit,
    query: jobCardStatus.query,
    status: jobCardStatus.status,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    manpower: manpower.manpowerList,
    searchedJobCard: commonData.relationshipSearch,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    searchManpower,
    getAllStatus,
    fetchRelationshipSearchData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(JobCardStatus);
